export default __webpack_public_path__ + "static/media/instantMeeting.db303c89.svg";